var _defs, _polygon, _polygon2, _polygon3, _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNovapointAirportMarkingSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "xaml",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#363545;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "NovapointAirportMarking_svg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "22.37 0 28 5.63 28 0 22.37 0"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "4 32 9.63 32 4 26.37 4 32"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "14.9 8.63 16.25 7.19 14.1 5.19 14.9 8.63"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M4,0V23.54L12.46,32h3.9L7.72,23.37,9.14,22,19.18,32h2.18L10.22,20.87l1.42-1.42L24.18,32h2.18L12.72,18.37,14.14,17,28,30.82V25.41L16.84,14.25l1.41-1.41L28,22.59V20.41l-8.66-8.66,1.41-1.41L28,17.59V15.41L21.84,9.25l1.41-1.41L28,12.59V8.46L19.54,0Zm7.67,16.75a4,4,0,0,1-.82-1.54,11.35,11.35,0,0,1-.24-2.75,11.09,11.09,0,0,0-.1-2,1.81,1.81,0,0,0-.5-.94,1.14,1.14,0,0,0-.82-.36,1.1,1.1,0,0,0-.78.4,1.12,1.12,0,0,0-.33.81,1.54,1.54,0,0,0,.52,1L7.36,12.46a2.66,2.66,0,0,1-.8-2,3.14,3.14,0,0,1,.88-1.82,2.78,2.78,0,0,1,1.87-1,2.25,2.25,0,0,1,1.74.64,3.11,3.11,0,0,1,.67.9,4.73,4.73,0,0,1,.35,1.23A10.18,10.18,0,0,1,12.13,12c0,.7,0,1.16,0,1.37a2.92,2.92,0,0,0,.11.56l2.23-2.39,1.12,1Zm6.9-7.39L17.31,8.18l-2.4,2.57-1.06-1L12.41,3.32l.94-1,4,3.72.72-.78,1.06,1L18.39,7l1.27,1.18Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNovapointAirportMarkingSvg);
export default __webpack_public_path__ + "static/media/NovapointAirportMarking_svg.838f506f77c9399ba363db6c85f3ce70.svg";
export { ForwardRef as ReactComponent };